import styled from '@emotion/styled'
import { ReactComponent as Square } from '../../../images/Square.svg'

export const CheckBoxSquare = styled(Square)`
  label: CheckBoxSquare;
  > g {
    fill: ${(props) => (props.error ? '#b33834' : '#a0a0a0')};
  }
`
